"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCellContent = void 0;

var _lodash = _interopRequireDefault(require("lodash.get"));

/* eslint-disable import/prefer-default-export */
// disable eslint rule for this file because we will have more exports later
var getCellContent = function getCellContent(column, rowData) {
  var cellData = (0, _lodash.default)(rowData, column.field);
  return column.render ? column.render({
    column: column,
    cellData: cellData,
    rowData: rowData
  }) : cellData;
};

exports.getCellContent = getCellContent;
